"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSimpleGroupQuery = exports.getVisibleGroupsQueryDef = exports.getSimpleSubjectQuery = exports.getSimpleBranchingQuery = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const util_1 = require("../util");
const classDependentTypes_1 = require("../classDependentTypes");
/* Constructs a dead simple query from one type to another
 * @param sourceType
 * @param targetType
 * @param adjacencyType
 * @param id
 * */
const getSimpleBranchingQuery = (sourceType, targetType, adjacencyType, id = undefined) => {
    return new util_1.BranchingQueryDefinition({
        id: id ?? `${sourceType}to${targetType}Query`,
        path: [
            {
                objectTypeId: targetType,
                adjacencyType,
                edgeTypeId: adjacencyType == iotv_v3_types_1.AdjacentType.CHILD ? (0, classDependentTypes_1.getParentEdgeTypeId)(targetType, sourceType) : (0, classDependentTypes_1.getParentEdgeTypeId)(sourceType, targetType),
            },
        ],
        subQueries: [],
    });
};
exports.getSimpleBranchingQuery = getSimpleBranchingQuery;
const getSimpleSubjectQuery = (type, id) => {
    return new util_1.BranchingQueryDefinition({
        id: id ?? `${type}ApexQuery`,
        path: [
            {
                objectTypeId: type,
                adjacencyType: iotv_v3_types_1.AdjacentType.SUBJECT,
            },
        ],
        subQueries: [],
    });
};
exports.getSimpleSubjectQuery = getSimpleSubjectQuery;
const getVisibleGroupsQueryDef = () => {
    return new util_1.BranchingQueryDefinition({
        id: 'visibleGroupsQuery',
        path: [
            {
                objectTypeId: 'Group',
                edgeTypeId: (0, classDependentTypes_1.getSpecificEdgeTypeId)('Group', 'Group', 'group_allows_group'),
                adjacencyType: iotv_v3_types_1.AdjacentType.CHILD,
            },
        ],
        subQueries: [],
    });
};
exports.getVisibleGroupsQueryDef = getVisibleGroupsQueryDef;
/** This line breaks jest. **/
// export const VisibleGroupsQueryDef = getVisibleGroupsQueryDef()
/** Gets a query from a source type to groups of supported type
 * @param supportedType - the supported type of the sought groups
 * @param adjacencyType - Which direction to look
 * @param [souceType="Group"] - (Optional) the type of the source object, default Group
 * @param [id=undefined] - (Optional) id for the query
 */
const getSimpleGroupQuery = (supportedType, adjacencyType, sourceType = 'Group', id = undefined) => {
    return new util_1.BranchingQueryDefinition({
        id: id ?? `${sourceType}To${supportedType}GroupQuery`,
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType,
                edgeTypeId: adjacencyType == iotv_v3_types_1.AdjacentType.CHILD ? (0, classDependentTypes_1.getParentEdgeTypeId)('Group', sourceType) : (0, classDependentTypes_1.getParentEdgeTypeId)(sourceType, 'Group'),
                nodeFilters: [
                    {
                        setOperation: iotv_v3_types_1.LogicalOperatorType.AND,
                        filters: [{ key: 'supportedType', predicate: iotv_v3_types_1.ComparisonType.EQUALS, value: supportedType }],
                    },
                ],
            },
        ],
        subQueries: [],
    });
};
exports.getSimpleGroupQuery = getSimpleGroupQuery;
